import threeLoginList from "@/layout/layout-login/data/threeLoginList";
import loginTypes from "@/layout/layout-login/data/loginTypes";
import { regMobile } from "@/util/util";

const url = encodeURIComponent('http://www.wenyule.cn/index');

export default {
    data() {
        return {
            mobile: '',
            password: '',
            input_type: true,
            threeLoginList,
            loginTypes,
            selected: 0,
            code: '',
            disabled: true,
            codeText: '获取验证码',
            appId: 'wxc3130db3c9ecdf8f',
            qqAppId: '101910915'
        }
    },

    created() {
        document.onkeydown = () => {
            if(window.event.keyCode === 13) {
                this.loginType()
            }
        };
    },

    destroyed() {
        this.initTimer();
    },


    methods: {

        initTimer() {
            if(this.timer) {
                clearInterval(this.timer);
            }
            this.codeText = '获取验证码';
            this.disabled = true;
        },


        // 获取验证码
        getCode() {
            if(!regMobile(this.mobile)) {
                this.$message.error('请输入正确的手机号！')
                return;
            }
            if(this.disabled) {
                this.$post('api.php/Index/sendCode',{
                    type: 3,
                    mobile: this.mobile
                }).then(res => {
                    if(res.status == 1) {
                        this.$message.success(res.info);
                        this.disabled = false;
                        let second = this.$second;
                        this.codeText = second + 's';
                        this.timer = setInterval(() => {
                            second--;
                            if (second >= 0) {
                                this.codeText = second + 's'
                            }else {
                                clearInterval(this.timer);
                                this.codeText = '重新获取';
                                this.disabled = true;
                            }
                        },1000);
                    }else {
                        this.$message.info(res.info);
                    }
                })


            }
        },

        loginType() {
            if(this.selected === 0) {
                this.codeLogin();
            }else {
                this.login();
            }
        },

        codeLogin() {
            if(!regMobile(this.mobile)){
                this.$message.error('请输入正确的手机号码！');
                return;
            }
            if(!this.code.trim()){
                this.$message.error('请输入验证码！');
                return;
            }
            this.$post('api.php/Index/login',{
                type: 1,
                mobile: this.mobile,
                code: this.code
            }).then(res => {
                if(res.status == 1) {
                    this.$message.success(res.info);
                    this.initTimer();
                    localStorage.setItem('userinfo',this.$Encrypt(JSON.stringify(res.data || {})));
                    this.$store.commit('setUser',res.data || {})
                    this.$parent.$parent.userinfo = this.$getUserinfo()
                    this.mobile = '';
                    this.code = '';
                    this.$parent.$parent.checkLogin();
                    this.$parent.$parent.closeMask();
                }else {
                    this.$message.info(res.info);
                }
            })
        },

        login() {
            if(!regMobile(this.mobile)){
                this.$message.error('请输入正确的手机号码！');
                return;
            }
            if(!this.password.trim()) {
                this.$message.error('请输入密码！');
                return;
            }
            this.$post('api.php/Index/login',{
                type: 2,
                mobile: this.mobile,
                password: this.password
            }).then(res => {

                if(res.status == 1) {
                    this.$message.success(res.info);
                    localStorage.setItem('userinfo',this.$Encrypt(JSON.stringify(res.data || {})));
                    this.$store.commit('setUser',res.data || {})
                    this.$parent.$parent.userinfo = this.$getUserinfo()
                    this.mobile = '';
                    this.password = '';
                    this.$parent.$parent.checkLogin();
                    this.$parent.$parent.closeMask();
                }else {
                    this.$message.info(res.info);
                }
            })
        },

        threeLogin(item) {
            // type 1、微信登录  2、QQ登录  3、微博登录
            if(item.type === 1) {
                this.getWechatCode();
            }else if(item.type === 2) {
                this.getQQCode();
            }
        },

        // 微信登录
        getWechatCode() {

            location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${this.appId}&redirect_uri=${url}&response_type=code&scope=snsapi_login&state=wechat#wechat_redirect`
        },

        getQQCode() {
            location.href = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${this.qqAppId}&redirect_uri=${url}&state=qq`
        },

        close() {
            this.$emit('close');
        },

        openReg() {
            this.$parent.$parent.openRegPop();
        },

        openForget() {
            this.$parent.$parent.openForgetPop();
        }

    }
}
